import { routeList } from '@/router/helpers/routes'
import { validateRouteMandatoryProps, revelockDataHandlerNotLogged } from '@/router/helpers/validations'
/* Views */
import RecoverCredentials from '@/views/nonAuthenticated/RecoverCredentials'
import PreActiveMode from '@/views/nonAuthenticated/PreActiveMode'
import PreActiveModeRecoverCredentials from '@/views/nonAuthenticated/PreActiveModeRecoverCredentials'
import Join from '@/views/nonAuthenticated/join/Join'
import JoinCreateAccount from '@/views/nonAuthenticated/join/CreateAccount'
import JoinSelfAdhesion from '@/views/nonAuthenticated/join/SelfAdhesion'

export default [{
    path: routeList.RECOVER_CREDENTIALS_PATH,
    name: routeList.RECOVER_CREDENTIALS_NAME,
    component: RecoverCredentials
},
/* ***********************************************
*                 PRE ACTIVE MODE                *
*********************************************** */
{
	path: routeList.NON_AUTHENTICATED_PRE_ACTIVE_MODE_PATH,
	name: routeList.NON_AUTHENTICATED_PRE_ACTIVE_MODE_NAME,
    props: true,
	component: PreActiveMode,
	beforeEnter (to, from, next) {
		revelockDataHandlerNotLogged(to)
		validateRouteMandatoryProps(to, from, next, routeList.LOGIN_NAME)
	}
}, {
	path: routeList.NON_AUTHENTICATED_PRE_ACTIVE_MODE_RECOVER_CREDENTIALS_PATH,
	name: routeList.NON_AUTHENTICATED_PRE_ACTIVE_MODE_RECOVER_CREDENTIALS_NAME,
    props: true,
	component: PreActiveModeRecoverCredentials,
	beforeEnter (to, from, next) {
		revelockDataHandlerNotLogged(to)
		validateRouteMandatoryProps(to, from, next, routeList.LOGIN_NAME)
	}
},
/* ***********************************************
*                        JOIN                    *
*********************************************** */
{
	path: routeList.NON_AUTHENTICATED_JOIN_PATH,
	name: routeList.NON_AUTHENTICATED_JOIN_NAME,
	component: Join,
	beforeEnter (to, from, next) {
		revelockDataHandlerNotLogged(to)
		next()
	}
}, {
	path: routeList.NON_AUTHENTICATED_JOIN_CREATE_ACCOUNT_PATH,
	name: routeList.NON_AUTHENTICATED_JOIN_CREATE_ACCOUNT_NAME,
	component: JoinCreateAccount,
	beforeEnter (to, from, next) {
		revelockDataHandlerNotLogged(to)
		next()
	}
}, {
	path: routeList.NON_AUTHENTICATED_JOIN_SELF_ADHESION_PATH,
	name: routeList.NON_AUTHENTICATED_JOIN_SELF_ADHESION_NAME,
	component: JoinSelfAdhesion,
	beforeEnter (to, from, next) {
		revelockDataHandlerNotLogged(to)
		next()
	}
}]
